var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuImpressum = function SvgMenuImpressum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "20 18 57 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu_impressum_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m71.58 21.59-.56.52a3 3 0 0 0-.48-.32 7 7 0 0 0-.75-.36L71.37 20H20l2.28 1.91a3.34 3.34 0 0 0-1.1 2.3 96 96 0 0 0-.11 10.59c.009.498.15.985.41 1.41.29 6.65.69 14.07.83 17.11a3 3 0 0 0 2.94 2.85q22.29 1.3 44.62 1.04a2.89 2.89 0 0 0 2.52-1.6c.1-.19-.81-34.02-.81-34.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M56.94 35.51c1.39-1.17 3.33-3.3 4.75-4.46 3.5-3 6.37-6.43 9.36-8.92a2.5 2.5 0 0 0-.47-.34 6 6 0 0 0-.89-.41c-7.27 5.27-20.78 15.52-23.87 17.49-4.13-2.27-18.45-13.18-23.53-16.95a3.17 3.17 0 0 0-1 1.65c2.19 1.93 4.53 4.29 7 6.39 2.17 1.85 4.31 4.4 6.49 6.15l-12.47 17.1a2.86 2.86 0 0 0 1.88 2.62L38 38.62a59 59 0 0 0 6.47 3.87 4.45 4.45 0 0 0 1.82.62 3.5 3.5 0 0 0 2.4-.7c1.86-1.18 3.14-2.7 5.14-4.3l16.21 19.1a2.89 2.89 0 0 0 2.35-1.58z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menu_impressum_svg__a",
    width: 80.398,
    height: 65.253,
    x: 8,
    y: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    stdDeviation: 1.717
  }), /*#__PURE__*/React.createElement("feOffset", {
    xmlns: "http://www.w3.org/2000/svg",
    dx: 2,
    dy: 2,
    result: "pf_100_offsetBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    xmlns: "http://www.w3.org/2000/svg",
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    xmlns: "http://www.w3.org/2000/svg",
    in2: "pf_100_offsetBlur",
    operator: "in",
    result: "pf_100_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    in2: "pf_100_dropShadow"
  })))));
};
export default SvgMenuImpressum;